(() => {
  const initialiseTabs = (root) => {
    root.querySelectorAll('[data-ltp-tabs]').forEach((tabs) => {
      if (tabs.dataset.ltpTabsInitialised === 'true') return;
      tabs.dataset.ltpTabsInitialised = 'true';

      const tabButtons = [...tabs.querySelectorAll('[data-ltp-tab]')];
      const panels = [...tabs.querySelectorAll('[data-ltp-tab-panel]')];

      const activateTab = (nextTab, moveFocus = false) => {
        tabButtons.forEach((tab) => {
          const selected = tab === nextTab;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
        });

        if (moveFocus) nextTab.focus();
      };

      tabButtons.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabButtons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabButtons.length) % tabButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabButtons.length - 1;
          if (nextIndex === undefined) return;

          event.preventDefault();
          activateTab(tabButtons[nextIndex], true);
        });
      });
    });
  };

  const initialiseDialog = (dialog) => {
    if (dialog.dataset.ltpDialogInitialised === 'true') return;
    dialog.dataset.ltpDialogInitialised = 'true';

    let returnFocusTarget = null;
    const triggers = [...document.querySelectorAll('[data-ltp-dialog-open]')].filter(
      (trigger) => trigger.dataset.ltpDialogOpen === dialog.id
    );

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        returnFocusTarget = trigger;
        dialog.showModal();
      });
    });

    dialog.querySelectorAll('[data-ltp-dialog-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', () => {
      if (returnFocusTarget?.isConnected) returnFocusTarget.focus();
    });

    initialiseTabs(dialog);
  };

  const initialiseSupportUx = (root = document) => {
    root.querySelectorAll('.ltp-v2-dialog').forEach(initialiseDialog);
    initialiseTabs(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseSupportUx());
  } else {
    initialiseSupportUx();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseSupportUx(event.target));
})();
